// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__ponKQ","message":"style__message__V-peA"};